import styled from 'styled-components';

import colors from 'theme/colors';
import fonts from 'theme/fonts';
import media from 'theme/media';

export const FlagWrapper = styled.span`
    height: 24px;
    margin-right: 24px;
    min-width: 24px;
    width: 24px;
`;
export const CountryName = styled.div`
    color: ${colors.mediumGray};
`;
export const ShowAll = styled.div`
    margin-top: 48px;
    padding-bottom: 2px;

    a {
        align-items: center;
        color: ${colors.purple};
        display: inline-flex;
        outline: none;
        text-decoration: none;

        &:focus-visible {
            outline: 1px dashed ${colors.superLightPurple};
        }
    }

    ${media.tablet648} {
        margin-top: 64px;
    }
`;
export const Countries = styled.ul`
    list-style-type: none;
    margin: 64px auto 48px;
    padding: 0;

    & > li {
        margin: 0;
        white-space: nowrap;

        a:focus-visible {
            background-color: ${colors.superLightGray};
            outline: 1px dashed ${colors.lightGray};

            ${CountryName} {
                color: ${colors.baseColor};
            }
        }

        ${media.tablet648} {
            -webkit-column-break-inside: avoid;
            break-inside: avoid;
        }
    }

    ${media.tablet648} {
        column-count: 2;
        column-gap: 85px;
        margin-bottom: 64px;
        margin-top: 96px;
    }

    ${media.desktop1352} {
        column-count: 3;
        column-gap: 80px;
    }
`;
export const Tags = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;

    & > li {
        margin: 0;
        white-space: nowrap;

        ${media.tablet648} {
            -webkit-column-break-inside: avoid;
            break-inside: avoid;
        }

        & > a {
            align-items: center;
            display: flex;
            outline: none;
            padding-bottom: 8px;
            padding-top: 8px;
            text-decoration: none;

            &:link,
            &:visited {
                color: ${colors.mediumGray};
            }

            &:hover {
                color: ${colors.purple};

                ${CountryName} {
                    color: ${colors.purple};
                }
            }
        }
    }
`;
export const Title = styled.div`
    margin-bottom: 16px;
`;
export const Description = styled.div`
    margin: 0;
`;
export const LeadText = styled.div`
    margin-bottom: 64px;
    margin-right: auto;
    max-width: 620px;

    ${media.tablet648} {
        margin-bottom: 96px;
    }
`;
export const LearnMore = styled.div`
    margin-right: 2px;

    ${media.tablet648} {
        margin-right: 4px;
    }
`;
export const SectionGeo = styled.section`
    font-family: ${fonts.regular};
    color: ${colors.baseColor};
    content-visibility: auto;
    margin-bottom: 96px;
    margin-top: 96px;

    ${media.tablet648} {
        margin-bottom: 128px;
        margin-top: 128px;
    }

    ${media.desktop1352} {
        margin-bottom: 128px;
        margin-top: 128px;
    }
`;
